import React, { useState } from "react";
import TrainingLogForm, {
  TrainingLogContext,
} from "../components/DayPost/training-log/TrainingLogForm";

// Isolated development surface for the new training log form.
// This route is intentionally not wired into the bottom nav / FAB yet — it
// exists so the new form can be built and verified in parallel with the
// existing AddTrainingLogForm without touching any live entry points.

const getTodayDateID = (): string => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}${month}${day}`;
};

const TrainingLogNew: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [lastSavedId, setLastSavedId] = useState<string | null>(null);

  const context: TrainingLogContext = {
    dateID: getTodayDateID(),
  };

  return (
    <div className="min-h-screen bg-base-100 p-6 flex flex-col items-center justify-center gap-6">
      <div className="max-w-md w-full space-y-4 text-center">
        <h1 className="text-2xl font-grotesk font-bold">
          New Training Log (preview)
        </h1>
        <p className="text-sm text-base-content/60">
          Isolated preview of the rebuilt training log form. Data and the load
          calculation match the original; only the UX is new. Date:{" "}
          <span className="font-mono">{context.dateID}</span>
        </p>

        <button
          type="button"
          onClick={() => setOpen(true)}
          className="w-full py-3 rounded-md bg-neutral text-white font-medium"
        >
          Open new training log form
        </button>

        {lastSavedId && (
          <p className="text-sm text-green-600">
            Saved training log: <span className="font-mono">{lastSavedId}</span>
          </p>
        )}
      </div>

      <TrainingLogForm
        open={open}
        onClose={() => setOpen(false)}
        context={context}
        onSaved={(id) => setLastSavedId(id)}
      />
    </div>
  );
};

export default TrainingLogNew;
